import type { Module } from "components/Admin/Organizations/types/Module.type";
import { filterModulesByCategory } from "../../_DataEndpointConfig/moduleSelector";
import type ChartCardStore from "../ChartCardStore";

/** The modules a chart's module dropdowns offer. */
export const getControlModules = (store: ChartCardStore): Module[] => {
    const allModulesCriteria =
        store.selectionType === "Tags" ||
        store.config.capabilities.canSelectAllModules;
    const orgModules = store.optionsStore.orgModules;
    const scoredModules = store.optionsStore.orgScoredModules;
    const defaultModules = allModulesCriteria
        ? orgModules
        : scoredModules.length
        ? scoredModules
        : orgModules;
    const fallbackModules =
        defaultModules === orgModules ? scoredModules : orgModules;
    const unscopedModules = defaultModules.length
        ? defaultModules
        : fallbackModules;

    // Some endpoints narrow the normal module list, such as showing only Quality modules.
    return filterModulesByCategory(
        unscopedModules,
        store.config.moduleSelector,
    );
};
